import VideoPlayer from "../components/description/Player";
import VideoDescription from "../components/description/VideoDescription";
import RelatedVideoList from "../components/list/RelatedVideoList";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import { fetchVideo } from "../features/video/videoSlice";
import Loding from "../components/ui/Loding";

export default function Video() {
  const dispatch = useDispatch();
  const { videoId } = useParams();

  useEffect(() => {
    dispatch(fetchVideo(videoId));
  }, [dispatch, videoId]);

  const state = useSelector((state) => state.video);
  // console.log(state);
  const { isLoding, isError, error, video } = state;
  const { link, title, id, tags } = video;
  let content;
  if (isLoding) {
    content = <Loding />;
  }
  if (!isLoding && isError) {
    content = error;
  }
  if (!isLoding && !isError && video.id) {
    content = (
      <div class="mx-auto max-w-7xl px-2 pb-20 min-h-[400px]">
        <div class="grid grid-cols-3 gap-2 lg:gap-8">
          <div class="col-span-full w-full space-y-8 lg:col-span-2">
            <VideoPlayer link={link} title={title} />

            <VideoDescription video={video} />
          </div>

          <RelatedVideoList id={id} tags={tags} />
        </div>
      </div>
    );
  }

  return <section class="pt-6 pb-20">{content}</section>;
}
